/* eslint-disable camelcase */
import Button from '@retracedgmbh/ui-components-lib/Button'
import React from 'react'
import {useToggleIntercomWidget} from '@state/intercom'

export default function IntercomCloseButton() {
  const {toggleWidget, showWidget} = useToggleIntercomWidget(state => ({
    toggleWidget: state.toggleWidget,
    showWidget: state.showWidget,
  }))
  if (!showWidget) return null
  return (
    <Button
      icon="fa fa-close"
      color="primary"
      onClick={() => {
        if(window && window.Intercom) {
          window.Intercom('update', {
            hide_default_launcher: true,
          })
          toggleWidget(false)
        }
      }}
      style={{
        position: 'fixed',
        zIndex: 20000,
        borderRadius: 100,
        padding: 0,
        bottom: 60,
        right: 10,
      }}
    />
  )
}
